export const BASE = 4;

export const SPACING_0B = '0px';
export const SPACING_1 = '1px';
export const SPACING_2 = '2px';
export const SPACING_1B = `${BASE}px`;
export const SPACING_6 = '6px'; // exception for tag, thus not to be used anywhere else
export const SPACING_14 = '14px';
export const SPACING_2B = `${2 * BASE}px`;
export const SPACING_3B = `${3 * BASE}px`;
export const SPACING_4B = `${4 * BASE}px`;
export const SPACING_5B = `${5 * BASE}px`;
export const SPACING_6B = `${6 * BASE}px`;
export const SPACING_7B = `${7 * BASE}px`;
export const SPACING_8B = `${8 * BASE}px`;
export const SPACING_9B = `${9 * BASE}px`;
export const SPACING_10B = `${10 * BASE}px`;
export const SPACING_11B = `${11 * BASE}px`;
export const SPACING_12B = `${12 * BASE}px`;
export const SPACING_13B = `${13 * BASE}px`;
export const SPACING_14B = `${14 * BASE}px`;
export const SPACING_15B = `${15 * BASE}px`;
export const SPACING_16B = `${16 * BASE}px`;
export const SPACING_17B = `${17 * BASE}px`;
export const SPACING_18B = `${18 * BASE}px`;
export const SPACING_20B = `${20 * BASE}px`;
export const SPACING_21B = `${21 * BASE}px`;
export const SPACING_22B = `${22 * BASE}px`;
export const SPACING_23B = `${23 * BASE}px`;
export const SPACING_24B = `${24 * BASE}px`;
export const SPACING_25B = `${25 * BASE}px`;
export const SPACING_26B = `${26 * BASE}px`;
export const SPACING_27B = `${27 * BASE}px`;
export const SPACING_28B = `${28 * BASE}px`;
export const SPACING_30B = `${30 * BASE}px`;
export const SPACING_32B = `${32 * BASE}px`;
export const SPACING_50B = `${50 * BASE}px`;

// To give two spaces in text when sending from function. &nbsp; just not work here.
export const SPACING_2SPACES = '\u00a0\u00a0';
export const SPACING_1SPACE = '\u00a0';

export const SPACING_HEADER = 72;
export const SPACING_HEADER_MARGIN = 40;
export const SPACING_FOOTER = 220;
export const SPACING_FOOTER_MARGIN = 40;
